import { Directive, HostBinding } from '@angular/core';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'ui-kit-error',
})
export class ErrorDirective {
  @HostBinding('class') class = 'error-msg';

  constructor() {}
}
